module.exports = __webpack_public_path__ + "static/item-8-19343e9c2758fac39a8f6d94abd513c8.png";